/* CLEARROOM — custom scripts */
(function () {
  'use strict';

  window.mtMoney = function (c, f) { return money(c, f); };

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-steps__list');
    if (!els.length) return;
    if (window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var h = document.querySelector('.mt-header');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initGallery() {
    document.querySelectorAll('[data-mt-gallery]').forEach(function (g) {
      var slides = g.querySelectorAll('.mt-gallery__main img, .mt-gallery__main svg.is-active');
      var thumbs = g.querySelectorAll('.mt-thumb');
      var count = g.querySelector('[data-mt-count]');
      var cur = 0;
      var go = function (i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        if (count) count.textContent = cur + 1;
        if (thumbs[cur] && thumbs[cur].scrollIntoView && thumbs.length > 5) {
          var box = thumbs[cur].parentNode; box.scrollTo({ left: thumbs[cur].offsetLeft - box.clientWidth / 2 + 38, behavior: 'smooth' });
        }
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      g.querySelectorAll('.mt-gallery__nav').forEach(function (b) {
        b.addEventListener('click', function () { go(cur + parseInt(b.dataset.dir, 10)); });
      });
      var main = g.querySelector('.mt-gallery__main');
      var x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
        });
      }
    });
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var f = format || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('comma') > -1) return v.replace('.', ',');
      if (k.indexOf('no_decimals') > -1) return Math.round(cents / 100);
      return v;
    });
  }

  function initProduct() {
    document.querySelectorAll('[data-mt-product]').forEach(function (root) {
      var form = root.querySelector('form[action*="/cart/add"]');
      var qty = root.querySelector('.mt-qty input');
      root.querySelectorAll('.mt-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          n = b.dataset.step === 'up' ? n + 1 : Math.max(1, n - 1);
          qty.value = n;
        });
      });

      var currentId = (form && form.querySelector('input[name="id"]')) ? form.querySelector('input[name="id"]').value : null;
      var syncBuy = function () {
        var n = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
        document.querySelectorAll('[data-mt-buynow]').forEach(function (a) {
          if (currentId) a.setAttribute('href', (a.dataset.cart || '/cart') + '/' + currentId + ':' + n);
        });
      };
      if (qty) { qty.addEventListener('change', syncBuy); qty.addEventListener('input', syncBuy); }
      root.querySelectorAll('.mt-qty button').forEach(function (b) { b.addEventListener('click', syncBuy); });

      var eta = root.querySelector('[data-mt-eta]');
      if (eta) {
        try {
          var mn = parseInt(eta.dataset.min, 10), mx = parseInt(eta.dataset.max, 10);
          if (mn > 0 && mx >= mn) {
            var d1 = new Date(), d2 = new Date();
            d1.setDate(d1.getDate() + mn); d2.setDate(d2.getDate() + mx);
            var o = { month: 'short', day: 'numeric' };
            var t = eta.querySelector('[data-mt-eta-text]');
            if (t) t.innerHTML = 'Order today, estimated arrival <b>' + d1.toLocaleDateString('en-US', o) + ' – ' + d2.toLocaleDateString('en-US', o) + '</b>';
          }
        } catch (err) {}
      }

      var dataEl = root.querySelector('[data-mt-variants]');
      var selects = root.querySelectorAll('.mt-variants select');
      if (dataEl && selects.length) {
        var variants = JSON.parse(dataEl.textContent);
        var fmt = root.dataset.moneyFormat;
        var idInput = form.querySelector('input[name="id"]');
        var priceEls = document.querySelectorAll('[data-mt-price]');
        var btns = document.querySelectorAll('[data-mt-add]');
        var update = function () {
          var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
          btns.forEach(function (b) {
            b.disabled = !v || !v.available;
            var label = b.querySelector('span');
            if (label) label.textContent = !v ? b.dataset.unavailable : (v.available ? b.dataset.add : b.dataset.soldout);
          });
          if (!v) return;
          idInput.value = v.id;
          currentId = v.id; syncBuy();
          priceEls.forEach(function (p) { p.textContent = money(v.price, fmt); });
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        };
        selects.forEach(function (s) { s.addEventListener('change', update); });
      }

      var sticky = document.querySelector('.mt-sticky-buy');
      var mainBtn = root.querySelector('.mt-buy');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var past = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', past);
          });
        }).observe(mainBtn);
      }
    });
  }


  /* ---------- V2: flip cards ---------- */
  function initFlips() {
    document.querySelectorAll('.mt-flip').forEach(function (card) {
      if (card.dataset.mtBound) return; card.dataset.mtBound = '1';
      var flip = function () {
        var on = card.classList.toggle('is-flipped');
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      };
      card.addEventListener('click', flip);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    });
  }

  /* ---------- V2: sticky home buy bar ---------- */
  function initHomebar() {
    var bar = document.querySelector('.mt-homebar');
    if (!bar || bar.dataset.mtBound) return; bar.dataset.mtBound = '1';
    var showAfter = parseInt(bar.dataset.showAfter || '600', 10);
    var hideEls = document.querySelectorAll('.mt-cta, .mt-footer');
    var hidden = false;
    if ('IntersectionObserver' in window && hideEls.length) {
      var vis = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) vis.add(e.target); else vis.delete(e.target); });
        hidden = vis.size > 0; update();
      });
      hideEls.forEach(function (el) { io.observe(el); });
    }
    function update() { bar.classList.toggle('is-visible', window.scrollY > showAfter && !hidden); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- V2: value calculator ---------- */
  function initValue() {
    document.querySelectorAll('[data-mt-value]').forEach(function (box) {
      if (box.dataset.mtBound) return; box.dataset.mtBound = '1';
      var price = parseInt(box.dataset.price, 10) || 0;
      var fmt = box.dataset.moneyFormat;
      var trips = box.querySelector('[data-trips]');
      var years = box.querySelector('[data-years]');
      var big = box.querySelector('.mt-value__big');
      var tOut = box.querySelector('[data-trips-out]');
      var yOut = box.querySelector('[data-years-out]');
      var total = box.querySelector('[data-total]');
      function fill(r) { var pct = (r.value - r.min) / (r.max - r.min) * 100; r.style.setProperty('--fill', pct + '%'); }
      function calc() {
        var t = parseInt(trips.value, 10), y = parseInt(years.value, 10);
        tOut.textContent = t; yOut.textContent = y;
        var per = Math.round(price / (t * y));
        big.textContent = money(per, fmt);
        if (total) total.textContent = t * y;
        fill(trips); fill(years);
      }
      trips.addEventListener('input', calc); years.addEventListener('input', calc);
      calc();
    });
  }

  /* ---------- V2: room scanner game ---------- */
  function initScanner() {
    document.querySelectorAll('.mt-scan').forEach(function (root) {
      if (root.dataset.mtBound) return; root.dataset.mtBound = '1';
      var room = root.querySelector('.mt-room');
      var cursor = root.querySelector('.mt-room__cursor');
      var leds = root.querySelectorAll('.mt-meter i');
      var foundEl = root.querySelector('[data-found]');
      var msg = root.querySelector('.mt-scan__msg');
      var hits = Array.prototype.slice.call(root.querySelectorAll('.mt-hit'));
      var R = 0.26, HIT = 0.085;
      var texts = { idle: msg.innerHTML, nothing: root.dataset.msgNothing, decoy: root.dataset.msgDecoy, close: root.dataset.msgClose, found: root.dataset.msgFound };
      var pos = null;
      function targets() { return hits.map(function (h) { return { el: h, x: parseFloat(h.dataset.x) / 100, y: parseFloat(h.dataset.y) / 100, decoy: h.dataset.decoy === '1' }; }); }
      var T = targets();
      function rel(e) {
        var r = room.getBoundingClientRect();
        return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height, px: e.clientX - r.left, py: e.clientY - r.top, ar: r.height / r.width };
      }
      function dist(a, b, ar) { var dx = a.x - b.x, dy = (a.y - b.y) * ar; return Math.sqrt(dx * dx + dy * dy); }
      function reading(p) {
        var best = 0, nearest = null, nd = 9;
        T.forEach(function (t) {
          if (t.el.classList.contains('is-found')) return;
          var d = dist(p, t, p.ar);
          var s = Math.max(0, 1 - d / R) * (t.decoy ? 0.62 : 1);
          if (s > best) best = s;
          if (d < nd) { nd = d; nearest = t; }
        });
        return { s: best, nearest: nearest, d: nd };
      }
      function paint(s) {
        var n = Math.round(s * leds.length);
        leds.forEach(function (l, i) { l.classList.toggle('on', i < n); l.classList.toggle('hot', i < n && n >= leds.length - 1); });
        cursor.classList.toggle('is-hot', n >= leds.length - 1);
      }
      function move(e) {
        pos = rel(e);
        room.classList.add('is-active');
        cursor.style.transform = 'translate(' + pos.px + 'px,' + pos.py + 'px)';
        var r = reading(pos); paint(r.s);
        if (r.s > 0.72 && r.nearest && !r.nearest.decoy) msg.innerHTML = texts.close;
      }
      function tap(e) {
        move(e);
        var r = reading(pos);
        if (r.nearest && r.d < HIT) {
          if (r.nearest.decoy) { msg.innerHTML = texts.decoy; return; }
          r.nearest.el.classList.add('is-found');
          if (navigator.vibrate) { try { navigator.vibrate(60); } catch (err) {} }
          var n = root.querySelectorAll('.mt-hit.is-found:not([data-decoy="1"])').length;
          var total = T.filter(function (t) { return !t.decoy; }).length;
          foundEl.textContent = n;
          msg.innerHTML = texts.found.replace('[label]', r.nearest.el.dataset.label);
          paint(reading(pos).s);
          if (n >= total) root.classList.add('is-done');
        } else if (r.s < 0.3) {
          msg.innerHTML = texts.nothing;
        }
      }
      room.addEventListener('pointermove', move);
      room.addEventListener('pointerdown', tap);
      room.addEventListener('pointerleave', function () { room.classList.remove('is-active'); paint(0); });
      var reset = root.querySelector('.mt-scan__reset');
      if (reset) reset.addEventListener('click', function () {
        hits.forEach(function (h) { h.classList.remove('is-found'); });
        root.classList.remove('is-done'); foundEl.textContent = '0'; msg.innerHTML = texts.idle; paint(0);
      });
    });
  }

  function start() {
    initReveal();
    initHeader();
    initGallery();
    initProduct();
    initFlips();
    initHomebar();
    initValue();
    initScanner();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
